<template>
  <div class="header">
    <img src="../assets/info/ai.png" alt="" srcset="">
    <span>量体虚拟试衣镜</span>
  </div>
</template>

<script>
export default {
  name: 'pageHeader',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .header{
    display: flex;
    align-items: center;
    justify-content: center;
    background: #0C1436;
    height: 1.61rem;
    color: #fff;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
    img{
      width: .98rem;
      height: .8rem;
      margin-right: .2rem;
    }
    span{
      font-size: .8rem;
      letter-spacing: 1px;
    }
  }
</style>
